"use strict";

exports.__esModule = true;
exports.SORT_ID = exports.SORT_BY_MAP = exports.MOBILE_DEFAULT_SORT_KEY = exports.DEFAULT_SORT_KEY = exports.DEFAULT_SORTING_LOGIC = void 0;
var SORT_ID = exports.SORT_ID = 'sort';
var SORT_BY_MAP = exports.SORT_BY_MAP = {
  CHEAPEST: {
    key: 'cheapestScore:asc',
    sortBy: 'cheapestScore',
    orderBy: 'asc'
  },
  BEST: {
    key: 'bestScore:asc',
    sortBy: 'bestScore',
    orderBy: 'asc'
  },
  SHORTEST: {
    key: 'shortestScore:asc',
    sortBy: 'shortestScore',
    orderBy: 'asc'
  },
  EARLIST_DEPARTURE: {
    key: 'departure:asc',
    sortBy: 'firstLegDepartureTime',
    orderBy: 'asc'
  },
  LATEST_DEPARTURE: {
    key: 'departure:desc',
    sortBy: 'firstLegDepartureTime',
    orderBy: 'desc'
  },
  EARLIST_ARRIVAL: {
    key: 'arrival:asc',
    sortBy: 'lastLegDepartureTime',
    orderBy: 'asc'
  },
  LATEST_ARRIVAL: {
    key: 'arrival:desc',
    sortBy: 'lastLegDepartureTime',
    orderBy: 'desc'
  }
};
var DEFAULT_SORT_KEY = exports.DEFAULT_SORT_KEY = SORT_BY_MAP.CHEAPEST.key;
var MOBILE_DEFAULT_SORT_KEY = exports.MOBILE_DEFAULT_SORT_KEY = SORT_BY_MAP.BEST.key;
var DEFAULT_SORTING_LOGIC = exports.DEFAULT_SORTING_LOGIC = 'a';